import './css/common.css'
import './css/app.css'
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from "react-router-dom"
import axios from 'axios';
import { MessageModal } from './component/modal/modal';
import { useDispatch, useSelector } from 'react-redux';
import { change_MyData } from '../store';
import { getAdminLoginDestination } from '../auth/loginDestination';
import { QRCodeCanvas } from 'qrcode.react';
import { CopyToClipboard } from "react-copy-to-clipboard/src";
import { Copy, Eye, EyeOff } from 'lucide-react';

function Login() {
    let navigate = useNavigate();
    let dispatch = useDispatch();

    const brand = useSelector((state) => state.brand);
    const hasCustomLogo = Boolean(process.env.REACT_APP_LOGO);

    const [id, setId] = useState("")
    const [password, setPassword] = useState("")
    const [message, setMessage] = useState("")
    const [modal, setModal] = useState(false)
    const [reload, setReload] = useState(false)
    const [otpData, setOtpData] = useState([])
    const [otpState, setOtpState] = useState(true)
    const [smsModal, setSmsModal] = useState(false)
    const [pinModal, setPinModal] = useState(false)
    const [loginUser, setLoginUser] = useState(null)
    const [inputDisabled, setInputDisabled] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const onChangeId = (e) => {
        setId(e.target.value)
    }

    const onChangePassword = (e) => {
        setPassword(e.target.value)
    }

    const onSubmit = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/admin/login", {
            adminId: id,
            password: password
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data

            if (tmp?.code === 1000) {
                const user = tmp?.data?.user ?? {};
                setLoginUser(user);

                if (tmp?.data?.requirePin) {
                    // PIN 인증 필요 (Agent) — PIN 성공 전까지 dispatch 하지 않음
                    setPinModal(true);
                } else if (tmp?.data?.requireSms) {
                    dispatch(change_MyData(user))
                    // SMS 인증 필요
                    setSmsModal(true);
                // } else if (tmp?.data?.requireOtp) {
                //     // OTP 인증 필요 (기존)
                //     dispatch(change_MyData(user))
                //     onSubmitAuth();
                } else {
                    dispatch(change_MyData(user))
                    // 바로 대시보드 진입
                    navigate(getAdminLoginDestination(user));
                }
            }
            else if (tmp?.code === 9998) {
                // 계정 잠금
                setMessage({ msg: tmp.msg })
                setInputDisabled(true);
            }
            else {
                // 4010: 비밀번호 실패 등
                setMessage({ msg: tmp.msg })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const onSubmitAuth = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/auth/generate-otp-secret", {
            id: id
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setOtpData(tmp?.data ?? [])
                setModal(true)
            }
            else if (tmp?.code === 2001) {
                setOtpState(false)
                setOtpData(tmp?.data ?? [])
                setModal(true)
            }
            else {
                setMessage({ msg: tmp.msg })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSubmit()
        }
    };

    return (
        <div className={`login ${hasCustomLogo ? "login--light-tenant" : ""}`} style={{ padding: "0 2rem" }}>
            {modal && (<Authentication id={id} otpState={otpState} setModal={setModal} otpData={otpData} setMessage={setMessage} />)}
            {smsModal && (<SmsAuthentication setModal={setSmsModal} setMessage={setMessage} userData={loginUser} />)}
            {pinModal && (<PinAuthentication setModal={setPinModal} setMessage={setMessage} userData={loginUser} setInputDisabled={setInputDisabled} />)}
            <MessageModal message={message} />
            <div className="container sm:px-10">
                <div className="block xl:grid grid-cols-2 gap-4">
                    <div className="hidden xl:flex flex-col min-h-screen">
                        <a href="" className="-intro-x flex items-center pt-5">
                            <img alt={`${brand.name} 로고`} src={brand.loginLogo} className={hasCustomLogo ? "tenant-login-logo" : "w-32"} />
                        </a>
                        <div className="my-auto">
                            <img alt="Midone - HTML Admin Template" className="-intro-x w-1/2 -mt-16" src="/img/illustration.svg" />
                            <div className="tenant-login-title -intro-x text-white font-medium text-4xl leading-tight mt-10">
                                {brand.name}  <br />
                                관리자
                            </div>
                            {/* <div className="-intro-x mt-5 text-lg text-white text-opacity-70 dark:text-slate-400">관리자 페이지</div> */}
                        </div>
                    </div>
                    <div className="h-screen xl:h-auto flex py-0 xl:py-0 my-0 xl:my-0" style={{ height: "100dvh" }}>
                        <div className="my-auto mx-auto xl:ml-20 bg-white dark:bg-darkmode-600 xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto">
                            <h2 className="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
                                관리자 로그인
                            </h2>
                            <div className="intro-x mt-2 text-slate-400 xl:hidden text-center"> {brand.name} - 관리자 페이지</div>
                            <div className="intro-x mt-8">
                                <form>
                                    <input type="text" id="login-id" className="intro-x login__input form-control py-3 px-4 block" placeholder="아이디" value={id} onChange={onChangeId} disabled={inputDisabled} />
                                    <div className="intro-x mt-4" style={{ position: "relative" }}>
                                        <input type={showPassword ? "text" : "password"} id="login-pw" autocomplete="off" className="login__input form-control py-3 px-4 block" style={{ paddingRight: "40px" }} placeholder="패스워드" value={password} onChange={onChangePassword} onKeyDown={handleKeyPress} disabled={inputDisabled} />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(v => !v)}
                                            tabIndex={-1}
                                            style={{ position: "absolute", top: "50%", right: "12px", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: 0, color: "#888", display: "flex", alignItems: "center", zIndex: 10 }}
                                        >
                                            {showPassword ? <EyeOff width={18} height={18} /> : <Eye width={18} height={18} />}
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div className="intro-x mt-5 xl:mt-8 text-center xl:text-left">
                                <button id="login-btn" className="btn btn-primary py-3 px-4 w-full xl:w-32 xl:mr-3 align-top" onClick={() => onSubmit()} disabled={inputDisabled}>
                                    로그인
                                </button>
                            </div>
                            {/* <div className="intro-x mt-10 text-slate-600 dark:text-slate-500 text-center xl:text-left">
                                <div className="text-primary dark:text-slate-200" onClick={() => setModal(true)}>이용약관</div>&nbsp;&nbsp;&nbsp;
                            </div> */}
                        </div>
                    </div>
                </div>
                <div style={{ position: "fixed", bottom: "25px", left: "50%", transform: "translateX(-50%)", textAlign: "right", color: "gray", fontSize: "10px", width: "100%", maxWidth: "1920px", margin: "0 auto", paddingRight: "10px" }}>
                    <div>이 사이트는 테스트 버전으로 허가받지 않은 업체는 사용이 불가합니다.</div>
                </div>
            </div>
        </div>
    )
}

function Authentication({ id, otpState, setModal, otpData, setMessage }) {
    let navigate = useNavigate();

    // ▼ 중복 클릭 방지용
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [otp, setOTP] = useState("")
    const otpInputRef = useRef(null);

    useEffect(() => {
        otpInputRef.current?.focus();
    }, []);

    const changeOTP = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) { // 숫자만 허용
            setOTP(value);
        }
    };

    const onSubmit = async () => {
        // 이미 제출 중이면 막기
        if (isSubmitting) return;
        setIsSubmitting(true);
        console.log(id, otp)
        try {
            await axios.post(process.env.REACT_APP_API + "/api/auth/verify-otp", {
                id: id,
                token: otp
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                console.log(tmp)
                if (tmp?.code < 2000) {
                    setModal(false)
                    // 로그인 후 리다이렉트는 App.js의 Route path="*"에서 처리
                    navigate('/')
                }
                else {
                    setMessage({ msg: tmp?.msg ?? "인증 실패" })
                }
            }).catch(error => {
                console.error(error);
            });
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div id="submerchants-modal" class="modal show_modal" tabindex="-1">
            <div className="modal-dialog">
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium mr-auto modal_title_sty">2차인증(Google Authenticator)</h2>
                        <button type="button" className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty" aria-expanded="false" data-tw-toggle="dropdown" onClick={() => setModal(false)}>
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="plus" className="lucide lucide-plus w-4 h-4" data-lucide="plus">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "20px", padding: "20px" }}>
                        {otpState && (
                            <>
                                <QRCodeCanvas value={otpData?.qrCode ?? ""} style={{ width: '150px', height: '150px' }} />
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                                    <div>{otpData?.secret ?? ""}</div>
                                    <CopyToClipboard text={otpData?.secret ?? ""}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setMessage({ msg: "복사성공" })}>
                                            <Copy size={15} />
                                        </div>
                                    </CopyToClipboard>
                                </div>
                            </>
                        )}
                        <div>
                            <label htmlFor="인증번호" className="form-label">인증번호</label>
                            <input
                                id="인증번호"
                                name="인증번호"
                                type="text"
                                className="form-control input-padding"
                                maxLength={6}
                                value={otp}
                                onChange={changeOTP}
                                ref={otpInputRef}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        onSubmit();
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-primary w-20 reg_btn"
                            onClick={() => onSubmit()}
                            disabled={isSubmitting} // 중복클릭 방지용 비활성화
                        >
                            인증
                        </button>
                        <input
                            type="button"
                            className="btn btn-primary w-20 close_btn"
                            onClick={() => setModal(false)}
                            style={{ backgroundColor: 'darkred', marginLeft: '10px', border: 'none' }}
                            value="닫기"
                        />
                    </div>
                </div>
            </div>
        </div >
    )
}

function SmsAuthentication({ setModal, setMessage, userData }) {
    let navigate = useNavigate();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [code, setCode] = useState("");
    const codeInputRef = useRef(null);

    useEffect(() => {
        codeInputRef.current?.focus();
    }, []);

    const changeCode = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setCode(value);
        }
    };

    const onSubmit = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/api/admin/sms/verify-code", {
                code: code
            }, {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code === 1000) {
                setModal(false);
                navigate(getAdminLoginDestination(userData));
            } else if (tmp?.code === 4002) {
                setMessage({ msg: "인증코드가 만료되었습니다. 재발송해주세요." });
            } else if (tmp?.code === 4003) {
                setMessage({ msg: "인증코드가 일치하지 않습니다." });
            } else {
                setMessage({ msg: tmp?.msg ?? "인증 실패" });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const onResend = async () => {
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/api/admin/sms/send-code", {}, {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code === 1000) {
                setMessage({ msg: "인증코드가 재발송되었습니다." });
            } else {
                setMessage({ msg: tmp?.msg ?? "재발송에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div id="sms-auth-modal" class="modal show_modal" tabindex="-1">
            <div className="modal-dialog">
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium mr-auto modal_title_sty">SMS 인증</h2>
                        <button type="button" className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty" onClick={() => setModal(false)}>
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-plus w-4 h-4">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "20px", padding: "20px" }}>
                        <div style={{ fontSize: "13px", color: "#666", textAlign: "center" }}>
                            등록된 휴대폰으로 인증코드가 발송되었습니다.<br />
                            인증코드를 입력해주세요. (유효시간 3분)
                        </div>
                        <div>
                            <label htmlFor="sms-code" className="form-label">인증코드</label>
                            <input
                                id="sms-code"
                                name="sms-code"
                                type="text"
                                className="form-control input-padding"
                                maxLength={6}
                                value={code}
                                onChange={changeCode}
                                ref={codeInputRef}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        onSubmit();
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div className="modal-footer" style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                        <button
                            type="button"
                            className="btn btn-primary w-20 reg_btn"
                            onClick={() => onSubmit()}
                            disabled={isSubmitting}
                        >
                            인증
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary w-20"
                            onClick={() => onResend()}
                            style={{ backgroundColor: '#475569', border: 'none' }}
                        >
                            재발송
                        </button>
                        <input
                            type="button"
                            className="btn btn-primary w-20 close_btn"
                            onClick={() => setModal(false)}
                            style={{ backgroundColor: 'darkred', border: 'none' }}
                            value="닫기"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

function PinAuthentication({ setModal, setMessage, userData, setInputDisabled }) {
    let navigate = useNavigate();
    let dispatch = useDispatch();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pin, setPin] = useState("");
    const pinInputRef = useRef(null);

    useEffect(() => {
        pinInputRef.current?.focus();
    }, []);

    const changePin = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setPin(value);
        }
    };

    const onSubmit = async () => {
        if (isSubmitting) return;
        if (!pin) {
            setMessage({ msg: "PIN 번호를 입력해주세요." });
            return;
        }
        setIsSubmitting(true);
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/api/admin/verify-pin", {
                pin: pin
            }, {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code === 1000) {
                // PIN 인증 성공 → MyData dispatch 후 대시보드 진입
                dispatch(change_MyData(userData));
                setModal(false);
                navigate(getAdminLoginDestination(userData));
            } else if (tmp?.code === 9998) {
                // 계정 잠금 → 로그인 화면으로
                setMessage({ msg: tmp.msg });
                setModal(false);
                setInputDisabled(true);
            } else if (tmp?.code === 9999) {
                // 세션 만료 → 로그인 화면으로
                setMessage({ msg: tmp.msg });
                setModal(false);
            } else {
                // 4011: PIN 실패
                setMessage({ msg: tmp?.msg ?? "PIN 인증 실패" });
                setPin('');
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const onCancel = async () => {
        // 취소 시 로그아웃 후 로그인 화면으로
        try {
            await axios.post(process.env.REACT_APP_API + "/api/admin/logout", {}, {
                withCredentials: true,
            });
        } catch (error) {
            console.error(error);
        }
        setModal(false);
    };

    return (
        <div id="pin-auth-modal" class="modal show_modal" tabindex="-1">
            <div className="modal-dialog">
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium mr-auto modal_title_sty">PIN 인증</h2>
                        <button type="button" className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty" onClick={() => onCancel()}>
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-plus w-4 h-4">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "20px", padding: "20px" }}>
                        <div style={{ fontSize: "13px", color: "#666", textAlign: "center" }}>
                            PIN 번호를 입력해주세요.
                        </div>
                        <div>
                            <label htmlFor="pin-code" className="form-label">PIN 번호</label>
                            <input
                                id="pin-code"
                                name="pin-code"
                                type="password"
                                className="form-control input-padding"
                                inputMode="numeric"
                                maxLength={4}
                                value={pin}
                                onChange={changePin}
                                ref={pinInputRef}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        onSubmit();
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div className="modal-footer" style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                        <button
                            type="button"
                            className="btn btn-primary w-20 reg_btn"
                            onClick={() => onSubmit()}
                            disabled={isSubmitting}
                        >
                            확인
                        </button>
                        <input
                            type="button"
                            className="btn btn-primary w-20 close_btn"
                            onClick={() => onCancel()}
                            style={{ backgroundColor: 'darkred', border: 'none' }}
                            value="취소"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login;
